import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Divider} from '../../../../../../../commons/components/divider'
import {getGroupedInvoiceItems} from '../../../../../../../commons/selectors/order'
import {ticketsHaveSeats} from '../../../../../../../commons/selectors/tickets'
import {useAppSelector} from '../../../../hooks/runtime'
import {getFormattedOrderCreatedDate} from '../../../../selectors/dates'
import {getSuccessfulOrder, isPreparingOrder} from '../../../../selectors/placed-order'
import cn from '../../../classnames.scss'
import {BackToSiteLink} from '../../../common/back-to-site-link'
import {InvoiceBreakdown} from '../../../invoice-breakdown'
import {InvoiceBreakdownSize} from '../../../invoice-breakdown/interfaces'
import {TableRow} from '../../../table-row'
import {TableRowType} from '../../../table-row/interfaces'
import s from './desktop.scss'
import {Item} from './item'
import {OrderWithSeating} from './order-with-seating'

export const Desktop = () => {
  const {t} = useTranslation()

  const order = useAppSelector(getSuccessfulOrder)
  const formattedOrderCreatedDate = useAppSelector(getFormattedOrderCreatedDate)
  const invoiceItems = getGroupedInvoiceItems(order)
  const orderHasSeats = ticketsHaveSeats(order?.tickets)
  const {
    orderNumber,
    invoice: {discount},
  } = order

  const columns = orderHasSeats
    ? [
        {content: t('ticketsThankYou.ticketName')},
        {content: t('orderSuccess_seatInfo')},
        {content: ''},
        {content: t('ticketsThankYou.price')},
      ]
    : [
        {content: t('ticketsThankYou.ticketName')},
        {content: t('ticketsThankYou.price')},
        {content: t('ticketsThankYou.quantity')},
        {content: t('ticketsThankYou.subTotal')},
      ]

  const config = {
    dataHook: DH.INVOICE_TITLES,
    itemKey: DH.INVOICE_TITLES,
    type: TableRowType.header,
    addDivider: true,
    columns,
  }

  return (
    <div className={classNames(cn.formLabelsColor, cn.textFont)}>
      <div className={s.orderInformation}>
        <div className={s.orderNumber} data-hook={DH.ORDER_NUMBER}>
          {t('ticketsThankYou.orderNo', {orderNumber})}
        </div>
        <div className={s.placedOn} data-hook={DH.PLACED_ON}>
          {t('ticketsThankYou.placedOn', {date: formattedOrderCreatedDate})}
        </div>
      </div>
      {orderHasSeats ? (
        <OrderWithSeating order={order} />
      ) : isPreparingOrder(order) ? (
        <Divider />
      ) : (
        <>
          <Divider />
          <div role="table">
            <div role="rowgroup">
              <TableRow config={config} />
              <div className={s.tickets} role="rowgroup">
                {invoiceItems.map((item, index) => (
                  <Item key={item.id} item={item} discount={discount} t={t} last={invoiceItems.length === index + 1} />
                ))}
              </div>
            </div>
          </div>
          <Divider />
        </>
      )}
      <InvoiceBreakdown containerClass={s.summaryDetails} size={InvoiceBreakdownSize.big} />
      <Divider />
      <BackToSiteLink className={s.link} />
    </div>
  )
}
